import { HomeActionTypes, HomeActions } from './home.actions';
import { IFormRequestInt, IFormRequestExt } from '../../../commons';
import { HomeError, HomeLoading } from 'src/commons/interfaces/screens.interface';
import { HomeConstants } from 'src/app/app.constant';

export interface State {
    error: HomeError[];
    loading: HomeLoading[];

    UserInt: IFormRequestInt | null;
    UserExt: IFormRequestExt | null;

    FormCCExceptDraft: IFormRequestInt | null;
    FormCCPendingApproval: IFormRequestInt | null;
    FormCCApproved: IFormRequestInt | null;

    FormMGExceptDraft: IFormRequestInt | null;

    FormCGExceptDraft: IFormRequestExt | null;
    FormCGPendingApproval: IFormRequestExt | null;
    FormCGApproved: IFormRequestExt | null;

    FormESExceptDraft: IFormRequestExt | null;
    FormESPendingApproval: IFormRequestExt | null;
    FormESApproved: IFormRequestExt | null;

    FormPPExceptDraft: IFormRequestExt | null;
    FormPPPendingApproval: IFormRequestExt | null;
    FormPPApproved: IFormRequestExt | null;

    // FormCIExceptDraft: IFormRequestExt | null;
    // FormCIPendingApproval: IFormRequestExt | null;
    // FormCIApproved: IFormRequestExt | null;

    // FormFOExceptDraft: IFormRequestExt | null;
    // FormFOPendingApproval: IFormRequestExt | null;
    // FormFOApproved: IFormRequestExt | null;
}

export const initialState: State = {
    error: initError(),
    loading: initiateLoading(),

    UserInt: null,
    UserExt: null,

    FormCCExceptDraft: null,
    FormCCPendingApproval: null,
    FormCCApproved: null,

    FormMGExceptDraft: null,

    FormCGExceptDraft: null,
    FormCGPendingApproval: null,
    FormCGApproved: null,

    FormESExceptDraft: null,
    FormESPendingApproval: null,
    FormESApproved: null,

    FormPPExceptDraft: null,
    FormPPPendingApproval: null,
    FormPPApproved: null

    //  FormCIExceptDraft: null,
    //  FormCIPendingApproval: null,
    //  FormCIApproved: null,

    //  FormFOExceptDraft: null,
    //  FormFOPendingApproval: null,
    //  FormFOApproved: null,
};

export function reducer(state = initialState, action: HomeActions): State {
    switch (action.type) {

        case HomeActionTypes.LoadUserIntState: {
            return {
                ...state,
                UserInt: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'UserInt')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadUserIntStateSuccess: {
            return {
                ...state,
                UserInt: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'UserInt')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadUserExtState: {
            return {
                ...state,
                UserExt: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadUserExtStateSuccess: {
            return {
                ...state,
                UserExt: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'UserExt')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        //FormCC
        case HomeActionTypes.LoadFormCCExceptDraftState: {
            return {
                ...state,
                FormCCExceptDraft: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCCExceptDraftStateSuccess: {
            return {
                ...state,
                FormCCExceptDraft: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCExceptDraft')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCCPendingApprovalState: {
            return {
                ...state,
                FormCCPendingApproval: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCPendingApproval')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCCPendingApprovalStateSuccess: {
            return {
                ...state,
                FormCCPendingApproval: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCPendingApproval')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCCApprovedState: {
            return {
                ...state,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCApproved')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCCApprovedStateSuccess: {
            return {
                ...state,
                FormCCApproved: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCCApproved')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        //FormMG
        case HomeActionTypes.LoadFormMGExceptDraftState: {
            return {
                ...state,
                FormMGExceptDraft: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormMGExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormMGExceptDraftStateSuccess: {
            return {
                ...state,
                FormMGExceptDraft: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormMGExceptDraft')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        //FormCG
        case HomeActionTypes.LoadFormCGExceptDraftState: {
            return {
                ...state,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCGExceptDraftStateSuccess: {
            return {
                ...state,
                FormCGExceptDraft: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGExceptDraft')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCGPendingApprovalState: {
            return {
                ...state,
                FormCGPendingApproval: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGPendingApproval')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCGPendingApprovalStateSuccess: {
            return {
                ...state,
                FormCGPendingApproval: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGPendingApproval')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCGApprovedState: {
            return {
                ...state,
                FormCGApproved: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGApproved')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormCGApprovedStateSuccess: {
            return {
                ...state,
                FormCGApproved: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormCGApproved')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        //FormES
        case HomeActionTypes.LoadFormESExceptDraftState: {
            return {
                ...state,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormESExceptDraftStateSuccess: {
            return {
                ...state,
                FormESExceptDraft: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESExceptDraft')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormESPendingApprovalState: {
            return {
                ...state,
                FormESPendingApproval: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESPendingApproval')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormESPendingApprovalStateSuccess: {
            return {
                ...state,
                FormESPendingApproval: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESPendingApproval')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormESApprovedState: {
            return {
                ...state,
                FormESApproved: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESApproved')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormESApprovedStateSuccess: {
            return {
                ...state,
                FormESApproved: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormESApproved')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        //FormPP
        case HomeActionTypes.LoadFormPPExceptDraftState: {
            return {
                ...state,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPExceptDraft')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormPPExceptDraftStateSuccess: {
            return {
                ...state,
                FormPPExceptDraft: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPExceptDraft')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormPPPendingApprovalState: {
            return {
                ...state,
                FormPPPendingApproval: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPPendingApproval')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormPPPendingApprovalStateSuccess: {
            return {
                ...state,
                FormPPPendingApproval: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPPendingApproval')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormPPApprovedState: {
            return {
                ...state,
                FormPPApproved: null,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPApproved')
                        return { ...val, isLoading: true }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadFormPPApprovedStateSuccess: {
            return {
                ...state,
                FormPPApproved: action.payload,
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === 'FormPPApproved')
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.LoadHomeStateInit: {
            return initialState;
        }

        case HomeActionTypes.LoadHomeStateFail: {
            return {
                ...state,
                // error: action.payload,
                error: state.error.map((val: HomeError) => {
                    if (val.form === action.payload.form)
                        return action.payload
                    else
                        return val;
                }),
                loading: state.loading.map((val: HomeLoading) => {
                    if (val.form === action.payload.form)
                        return { ...val, isLoading: false }
                    else
                        return val;
                })
            };
        }

        case HomeActionTypes.HomeScreenErrorReset: {
            return {
                ...state,
                loading: initiateLoading()
            };
        }
        default: {
            return state;
        }
    }
}

function checkProperties(obj: any, prop: string): boolean {
    for (var key in obj) {
        if (obj[key] === undefined && key !== prop)
            return true;
    }
    return false;
}

function initiateLoading(): HomeLoading[] {
    let result: HomeLoading[] = [];
    HomeConstants.forEach((item) => {

        const newPending: HomeLoading =
        {
            isLoading: false,
            form: item,
            loadingMessage: ''
        }
        result.push(newPending);
    })
    return result;

}
function initError(): HomeError[] {
    let result: HomeError[] = [];
    HomeConstants.forEach((item) => {

        const newError: HomeError =
        {
            hasError: false,
            errorMessage: '',
            form: item
        }
        result.push(newError);
    })
    return result;

}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.loading;

export const getUserInt = (state: State) => state.UserInt;
export const getUserExt = (state: State) => state.UserExt;

export const getFormCCExceptDraft = (state: State) => state.FormCCExceptDraft
export const getFormCCPendingApproval = (state: State) => state.FormCCPendingApproval
export const getFormCCApproved = (state: State) => state.FormCCApproved

export const getFormMGExceptDraft = (state: State) => state.FormMGExceptDraft

export const getFormCGExceptDraft = (state: State) => state.FormCGExceptDraft
export const getFormCGPendingApproval = (state: State) => state.FormCGPendingApproval
export const getFormCGApproved = (state: State) => state.FormCGApproved

export const getFormESExceptDraft = (state: State) => state.FormESExceptDraft
export const getFormESPendingApproval = (state: State) => state.FormESPendingApproval
export const getFormESApproved = (state: State) => state.FormESApproved

export const getFormPPExceptDraft = (state: State) => state.FormPPExceptDraft
export const getFormPPPendingApproval = (state: State) => state.FormPPPendingApproval
export const getFormPPApproved = (state: State) => state.FormPPApproved


